import { render, staticRenderFns } from "./Methodology.vue?vue&type=template&id=7d238718&scoped=true&"
import script from "./Methodology.vue?vue&type=script&lang=js&"
export * from "./Methodology.vue?vue&type=script&lang=js&"
import style0 from "./Methodology.vue?vue&type=style&index=0&id=7d238718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d238718",
  null
  
)

export default component.exports